/** Models */
import { BydUserAccount } from './byd-user-account';

/** Interfaces */
import { BydUserAccountLoginInterface } from '../interfaces/byd-user-account-login.interface';
import { BydUserAccountInterface } from '../interfaces/byd-user-account.interface';

export class BydUserAccountLogin {
  /**
   * The auth state.
   */
  public isLoggedIn?: boolean;

  /**
   * The user information.
   */
  public account?: BydUserAccountInterface;

  /**
   * The user token.
   */
  public token?: string;

  /**
   * The refresh token is used to obtain new access/refresh
   * token pairs when the current access token expires
   */
  public refreshToken?: string;

  /**
   * Creates an instance of BydUserAccountLogin.
   *
   * @param jsonData the user account login data
   * @memberof BydUserAccountLogin
   */
  constructor(jsonData: BydUserAccountLoginInterface) {
    this.isLoggedIn = !!jsonData.token;
    this.account = jsonData.account ? new BydUserAccount(jsonData.account) : null;
    this.token = jsonData.token;
    this.refreshToken = jsonData.refreshToken;
  }
}
